import React, { useMemo, useEffect, useState, useCallback, useRef } from "react";
import update from "immutability-helper";

import { TABLE_DATA, DiffFunction, DiffFunctionDeleteRow, DiffFunctionDeleteSO } from "util";

import DataTableRow from "./DataTableRow";

const UPDATE_COLOR = "rgb(173, 228, 234)";

const makeInitialData = (d, type) => {
    let tmp;
    let fidx;
    let tmparr = [];
    tmp = TABLE_DATA?.[type];
    try {
        d.forEach((dd) => {
            Object.keys(dd).forEach((k) => {
                fidx = tmp.findIndex((i) => i.name === k);
                if (fidx > -1)
                    tmp = update(tmp, {
                        [fidx]: { $merge: { value: dd[k] } },
                    });
                if (k === "samplePoint") {
                    tmp = update(tmp, {
                        [fidx]: { $merge: { label: dd["samplePointNm"] } },
                    });
                } else if (k === "optionCd") {
                    tmp = update(tmp, {
                        [fidx]: { $merge: { label: dd["optionCd"] } },
                    });
                
                }
            });
            tmparr = [...tmparr, ...[tmp]];
        });
    } catch (e) {
        Object.keys(d).forEach((k) => {
            fidx = tmp.findIndex((i) => i.name === k);
            if (fidx > -1)
                tmp = update(tmp, {
                    [fidx]: { $merge: { value: d[k] } },
                });
            tmparr = [...tmp];
        });
    }
    
    return tmparr;
};

const DataTable = (props) => {
    const { _tblData, type } = props;

    const tableRef = useRef(null);

    const initialDataSet = useCallback(() => {
        const data = _tblData?.[type];

        let newVal = [];
        let tmparr;

        data?.forEach((d) => {
            tmparr = makeInitialData(d, type);

            newVal = [...newVal, [...tmparr]];
        });

        return newVal;
    }, [_tblData, type]);

    const renderFunc = () => {
        const data = initialDataSet();
        const initialData = TABLE_DATA?.[type];
        const colSpan = initialData.filter((f) => f.type2 !== "hidden").length - 1;
        const so = _tblData?.sub;

        let diffData;
        if (type === "composition") {
            const deletedRow = makeInitialData(
                DiffFunctionDeleteRow(type, null, _tblData.compare),
                type
            );
            const ret = data?.map((rowData, index) => {
                if (_tblData?.compare) {
                    diffData = DiffFunction(type, rowData, _tblData.compare);
                }
                return (
                    <DataTableRow
                        index={index}
                        rowData={rowData}
                        difftype={diffData?.type}
                        diffdata={diffData?.data}
                        key={"diffdata_innerData" + type + "_" + index}
                    />
                );
            });
            ret.push(
                deletedRow.map((rowData, index) => {
                    return (
                        <DataTableRow
                            index={index}
                            rowData={rowData}
                            difftype={"delete"}
                            key={"diffdata_innerData" + type + "_D" + index}
                        />
                    );
                })
            );
            return ret;
        } else {
            const soCompare = _tblData?.compare?.subD;
            const ret = so.map((k, i) => {
                // if (sso > -1) {
                //     if (i !== sso) {
                //         return null;
                //     }
                // }
                let markS;
                let deletedRow;
                if (_tblData.compare) {
                    if (
                        soCompare?.diffUpd?.[k.uniqueCode]?.[type + "Remark"] ||
                        soCompare?.diffAdd.includes(k.uniqueCode)
                    ) {
                        markS = UPDATE_COLOR;
                    }
                    deletedRow = makeInitialData(
                        DiffFunctionDeleteRow(type, k.uniqueCode, _tblData.compare),
                        type
                    );
                }
                if (data[i]?.length < 1) return null;
                let remark = k[type + "Remark"];
                return (
                    <React.Fragment key={"diffdata" + type + "_" + i}>
                        <tr>
                            <td colSpan={colSpan} className="name" style={{ textAlign: "center" }}>
                                <div className={"namename"}>{k.soSeq + "." + k.description}</div>
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={colSpan}
                                    className="soremark"
                                    style={{ backgroundColor: markS }}
                                >
                                    <div>{remark}</div>
                                </td>
                            </tr>
                        )}
                        {data[i]?.map((rowData, index) => {
                            if (_tblData?.compare) {
                                diffData = DiffFunction(type, rowData, _tblData.compare);
                            }
                            return (
                                <DataTableRow
                                    index={index}
                                    rowData={rowData}
                                    difftype={diffData?.type}
                                    diffdata={diffData?.data}
                                    key={"diffdata_innerData" + type + "_" + index}
                                />
                            );
                        })}
                        {deletedRow?.map((rowData, index) => {
                            return (
                                <DataTableRow
                                    index={index}
                                    rowData={rowData}
                                    difftype={"delete"}
                                    key={"diffdata_innerData" + type + "_D" + index}
                                />
                            );
                        })}
                    </React.Fragment>
                );
            });
            if(soCompare?.diffDel && _tblData.compare?.[type+"D"]?.diffDel?.length > -1) {
                const deletedStyle = {backgroundColor: "rgb(255, 212, 212)", color: "rgb(153, 153, 153)", textDecoration: "line-through"}
                const deleted = DiffFunctionDeleteSO(soCompare?.diffDel, _tblData.compare?.[type+"D"]?.diffDel);
                const { so, data } = deleted;
                const deletedSo = so.map((k, i) => {
                    if (data[i]?.length < 1) return null;
                    let remark = k[type + "Remark"];
                    const _data = makeInitialData(data[i], type);
                    
                    return (
                        <React.Fragment key={"diffdata" + type + "_SD" + i}>
                            <tr>
                                <td colSpan={colSpan} className="name" style={{ ...deletedStyle, textAlign: "center" }}>
                                    <div className={"namename"}>{k.soSeq + "." + k.description}</div>
                                </td>
                            </tr>
                            {remark !== "FALSE" && (
                                <tr style={deletedStyle}>
                                    <td
                                        colSpan={colSpan}
                                        className="soremark"
                                    >
                                        <div>{remark}</div>
                                    </td>
                                </tr>
                            )}
                            {_data?.map((rowData, index) => {
                                return (
                                    <DataTableRow
                                        index={index}
                                        rowData={rowData}
                                        difftype={"delete"}
                                        key={"diffdata_innerData" + type + "_SD" + index}
                                    />
                                );
                            })}
                        </React.Fragment>
                    );
                })
                ret.push([...deletedSo]);
            }
            return ret;
        }
    };

    const render = useMemo(renderFunc, [
        _tblData.compare,
        _tblData?.sub,
        initialDataSet,
        // sso,
        type,
    ]);

    const headerRender = useMemo(() => {
        return TABLE_DATA.header?.[type](_tblData.header, false, {
            diffData: _tblData.compare?.headDiff,
        }, true);
    }, [_tblData.compare?.headDiff, _tblData.header, type]);

    useEffect(() => {
        const headerHeight = tableRef.current?.querySelector("thead")?.offsetHeight;
        tableRef.current?.querySelectorAll("td.name").forEach(e => {
            e.style.top = headerHeight+"px";
        })
    },[_tblData])

    return (
        <>
            <table
                ref={tableRef}
                className={"bpl-table-default fixed borderBottom small sticky-header"}
                style={{ fontSize: "0.7rem" }}
                
            >
                {headerRender}
                <tbody>{render}</tbody>
            </table>
        </>
    );
};

const isEquals = (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next);
};

export default React.memo(DataTable, isEquals);
